export const GetParameter = (api, paramName, paramType, isEncrypted) => { //paramType = (num, char, date, bool)
    const tmpIsEncrypted = isEncrypted ? true : false
    return api.get(`api/v1/Parameter/GetParameter?paramName=${paramName}&paramType=${paramType}&isEncrypted=${tmpIsEncrypted}`)
}

export const IsWorkingDay = (api, date) => {
    var data = {
        Date: date,
    }
    return api.post(`api/v1/Parameter/isWorkingDay`, data)
}

export const GetLicense = (api) => {
    return api.get('api/v1/Parameter/getLicense')
}